import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=42aadc65&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=42aadc65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aadc65",
  null
  
)

export default component.exports